import React, { createContext, useState, useContext } from 'react';
import { LoadingOverlay } from '@mantine/core';
import colors from '../utils/colors';

interface LoadingContextProps {
  loading: boolean;
  setLoading: (value: boolean) => void;
}

const LoadingOverlayContext = createContext<LoadingContextProps>({
  loading: false,
  setLoading: () => {},
});

export const useLoadingOverlay = () => useContext(LoadingOverlayContext);

export const LoadingOverlayProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingOverlayContext.Provider value={{ loading, setLoading }}>
      {children}
      <LoadingOverlay
        visible={loading}
        zIndex={2000}
        style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
        overlayProps={{ radius: 'sm', blur: 3 }}
        loaderProps={{ color: colors.custom36s, type: 'bars' }}
        transitionProps={{ transition: 'fade', duration: 200 }}
      />
    </LoadingOverlayContext.Provider>
  );
};
